var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1546_119850)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1546_119850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5982 19.5268L17.1696 17.7232C16.0893 17.4196 15.3304 16.4375 15.3304 15.3393C15.3304 13.9732 16.4732 12.8571 17.875 12.8571H21.8929C22.8929 12.8571 23.8482 13.1786 24.625 13.7589C24.9107 13.9732 25.3036 13.9375 25.5536 13.6875L26.5625 12.6607C26.8661 12.3571 26.8304 11.8571 26.4911 11.5893C25.1875 10.5536 23.5804 9.99107 21.8839 9.99107H21.4286V6.41964C21.4286 6.02679 21.1071 5.70536 20.7143 5.70536H19.2857C18.8929 5.70536 18.5714 6.02679 18.5714 6.41964V9.99107H17.875C14.9018 9.99107 12.4732 12.3839 12.4732 15.3304C12.4732 17.7054 14.0893 19.8125 16.3929 20.4643L22.8214 22.2679C23.9018 22.5714 24.6607 23.5536 24.6607 24.6518C24.6607 26.0179 23.5179 27.1339 22.1161 27.1339H18.0982C17.0982 27.1339 16.1429 26.8125 15.3661 26.2321C15.0804 26.0179 14.6875 26.0536 14.4375 26.3036L13.4286 27.3304C13.125 27.6339 13.1607 28.1339 13.5 28.4018C14.8036 29.4375 16.4107 30 18.1071 30H18.5714V33.5714C18.5714 33.9643 18.8929 34.2857 19.2857 34.2857H20.7143C21.1071 34.2857 21.4286 33.9643 21.4286 33.5714V30H22.125C25.0982 30 27.5268 27.6071 27.5268 24.6607C27.5179 22.2857 25.9107 20.1786 23.5982 19.5268V19.5268ZM35.7143 0H4.28571C1.91964 0 0 1.91964 0 4.28571V35.7143C0 38.0804 1.91964 40 4.28571 40H35.7143C38.0804 40 40 38.0804 40 35.7143V4.28571C40 1.91964 38.0804 0 35.7143 0ZM37.1429 35.7143C37.1429 36.5 36.5 37.1429 35.7143 37.1429H4.28571C3.5 37.1429 2.85714 36.5 2.85714 35.7143V4.28571C2.85714 3.5 3.5 2.85714 4.28571 2.85714H35.7143C36.5 2.85714 37.1429 3.5 37.1429 4.28571V35.7143Z",
    fill: "#61A578"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1546_119850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1546_119850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFee);
export default __webpack_public_path__ + "static/media/fee.815f083eb1fdc1adecccd2e198ed6256.svg";
export { ForwardRef as ReactComponent };